export default __webpack_public_path__ + "static/media/EggType.96ea1d7c.jpg";